import React from 'react';
import {Box, ResultSubject, Text} from '../../../../styled';
import OfficeIcon from './OfficeIcon';
import HighlightMarker from '../../../../components/HighlightMarker/HighlightMarker';


const ContactsSnippet = ({ item }: any) => {
  const contacts = [];
  const phone = item.mobilePhone || item.businessPhones[0] || item.homePhones[0]
  if (phone) {
    contacts.push((
      <a href={`tel:${phone}`}>{phone}</a>
    ));
  }
  if (item.emailAddresses && item.emailAddresses[0]) {
    contacts.push((
      <a href={`mailto:${item.emailAddresses[0].address}`}>{item.emailAddresses[0].address}</a>
    ));
  }
  if (item.jobTitle) {
    contacts.push(item.jobTitle)
  }

  return (
    <Box>
      <ResultSubject>
        <OfficeIcon type="contacts" noMargin />
        <span style={{ paddingRight: 5 }} />
        <HighlightMarker>{item.title}</HighlightMarker>
        <div style={{ width: 30, display: 'inline-block' }}>
          <OfficeIcon type="outlook" />
        </div>
      </ResultSubject>
      <HighlightMarker>
        <Text color="#828282">
          {contacts.reduce((prev, curr) => [prev, ' | ', curr])}
        </Text>
      </HighlightMarker>
      <Text variant="muted" size="small">
        Contacts from {item.contactFrom}
      </Text>
    </Box>
  )
}

export default ContactsSnippet;